import React, { useState } from 'react';
import {
  Select, MenuItem, FormControl, FormHelperText, InputLabel, ListSubheader, Tooltip,
} from '@mui/material';
import { useSelector } from 'react-redux';
import IconPopup from 'screens/shared/help-icon-popup';
import Icon from 'screens/shared/icon';
import { generateId } from 'utils/generator';

export default ({
  label, values, value, error, style = {}, helpText = '', info = '', getOptionsStoreMap, clearable, element, labelClassName = '', ...props
}) => {
  const [labelId] = useState(generateId('label-'));
  const store = useSelector(getOptionsStoreMap || ((e) => e));

  if (getOptionsStoreMap) values = store;

  const getMenuItems = (e) => {
    if (Array.isArray(e)) {
      const [key, localValue, description, disabled, tooltip = ''] = e;
      const wrap = (elem) => (
        disabled && tooltip // this is not working for non-disabled items!
          ? (
            <Tooltip
              key={key}
              title={tooltip}
              enterDelay={200}
              followCursor
              PopperProps={{
                style: { pointerEvents: 'none' },
              }}
            >
              <div>{elem}</div>
            </Tooltip>
          )
          : elem
      );
      if (description) {
        return wrap(
          <MenuItem key={key} value={key} disabled={disabled}>
            <div className="dropdown-menu-item" title={tooltip}>
              <div>
                {localValue}
              </div>
              <div className="label-description-item">
                <span className="select-description">{description}</span>
              </div>
            </div>
          </MenuItem>,
        );
      }
      return wrap(
        <MenuItem key={key} value={key} disabled={disabled}>
          {localValue || key}
        </MenuItem>,
      );
    }
    return <MenuItem key={e} value={e}>{e}</MenuItem>;
  };

  // only set value if values is set => otherwise warning because value out of bounce
  const hasValues = Array.isArray(values) ? !!values.length : !!Object.keys(values).length;
  const currentValue = hasValues ? value : '';
  return (
    <FormControl variant="outlined" className="dropdown" error={!!error} style={style}>
      <InputLabel id={labelId} className={labelClassName}>
        {label}
      </InputLabel>
      <div>
        <Select
          labelId={labelId}
          label={label}
          name={label}
          displayEmpty
          error={!!error}
          value={currentValue}
          disabled={!hasValues}
          {...props}
        >
          {!Array.isArray(values) ? Object.keys(values).map((key) => (
            [
              <ListSubheader>{values[key].label}</ListSubheader>,
              values[key].items.map((e) => getMenuItems(e)),
            ]
          )) : values.map((e) => getMenuItems(e))}
        </Select>
        {
          clearable && value && (
            <div className="clearSelect">
              <Icon name="times-circle" onClick={() => props.onChange({ target: { value: '' } })} />
            </div>
          )
        }
      </div>
      {
        (!!helpText && !error) && (
          <FormHelperText style={{ marginLeft: 0 }}>
            {helpText}
            { info && <IconPopup content={info} /> }
          </FormHelperText>
        )
      }

      {!!error && <FormHelperText>{error}</FormHelperText>}
      { element }
    </FormControl>
  );
};
